export const ONBOARDING_LIST = "ONBOARDING_LIST";
export const ONBOARDING_REVIEW = "ONBOARDING_REVIEW";

export enum KYCCaseStatus {
  InProgress = "inProgress",
  CompletedNotYetTransacting = "completedNotYetTransacting",
  CompletedTransacting = "completedTransacting",
  Cancelled = "cancelled",
}

export enum KYCStatus {
  Requested = "requested",
  CustomerVerification = "customer_verification",
  Live = "live",
  Cancelled = "cancelled",
}

export const KYCCancelInfo = [
  {
    key: "Incomplete or Incorrect Documentation",
    value: "Customer fails to provide the required documents or submits invalid/incorrect information."
  },
  {
    key: "The merchant requested cancellation",
    value: "The customer voluntarily withdraws their KYC application or decides not to proceed with the process."
  },
  {
    key: "The merchant remains unresponsive to the verification requirements",
    value: "The KYC process is not completed within the set timeframe, causing the request to expire or be canceled."
  },
  {
    key: "Merchant verification requirements not met",
    value: "The customer does not meet regulatory criteria, such as failing to pass country-specific restrictions or compliance checks."
  },
  {
    key: "Duplicate signup request",
    value: "A duplicate request is identified, usually because the customer has already completed or submitted multiple KYC applications."
  },
];

export enum DateType {
  StartedOn = "started_on",
  CompletedOn = "completed_on",
}

export enum TrustType {
  BareTrusts = "bare_trusts",
  CharitableTrusts = "charitable_trusts",
  DiscretionaryTrusts = "discretionary_trusts",
  FixedTrusts = "fixed_trusts",
  HybridTrusts = "hybrid_trusts",
  UnitTrusts = "unit_trusts",
  SuperannuationTrusts = "superannuation_trusts",
  TestamentaryTrusts = "testamentary_trusts",
}

export enum RepresentativeEntityType {
  Person = "person",
  Trust = "trust",
  Company = "company",
}

export enum CompanyType {
  Private = "private",
  Partnership = "partnership",
  Corporation = "corporation",
  Other = 'other'
}
